import React, { FC } from 'react'

import { FormikFormProps } from '../../../form/FormikForm'
import { FormSubmitButtonProps } from '../../../form/FormSubmitButton'
import FormikField from '../../../form/FormikField'
import { FormErrorsProps } from '../../../form/FormErrors'
import { FormFieldSelectProps } from '../../../form/fields/FormFieldSelect'
import { CardProps } from '../../../Card'

import * as SC from './styled'

export type PickCCIValues = {
  cci: string
}

export type PickCCIProps = {
  className?: string
  header: CardProps['header']
  content: {
    title: string
    formikForm: FormikFormProps<PickCCIValues>
    fields: {
      cci: FormFieldSelectProps
    }
    errors?: FormErrorsProps['errors']
    submitButton: FormSubmitButtonProps
  }
}

const PickCCI: FC<PickCCIProps> = ({
  className,
  header,
  content: { title, formikForm, fields, submitButton, errors },
}) => {
  return (
    <SC.CardWrapper className={className} header={header}>
      <SC.Title>{title}</SC.Title>
      <SC.Divider />
      <SC.Form className={className} {...formikForm}>
        <SC.Fields>
          <FormikField {...fields.cci} Component={SC.FieldSelect} />
        </SC.Fields>
        {errors && <SC.Errors errors={errors} />}
        <SC.SubmitButton {...submitButton} />
      </SC.Form>
    </SC.CardWrapper>
  )
}

export default PickCCI
